import services from "./services"
import search from './search/search.vue'
import areaSelect from 'area-select';
import Uploader from 'uploader';
import followUpDialog from 'follow-up-dialog';
import schoolDetails from '../components/schoolDetails.vue';
import official from '../components/official/index.vue';
export default {
    mixins: [services],
    components: {
        official,
        search,
        areaSelect,
        'follow-up-dialog': followUpDialog,
        schoolDetails
    },
    data() {
        /*电话号码验证*/
        var checkPhone = (rule, value, callback) => {
            if (!/^[0-9]{11}$/.test(value)) {
                return callback(new Error("请输入11位数字"))
            } else {
                callback();
            }
        }
        return {
            dialogVisible: false, //添加列表弹窗的按钮
            loading: false,
            lists: [], //表格内容列表{"CourseId":3,"CourseName":"英语上","SubjectId":1,"SubjectName":"英语","VolumeType":1,"VolumeTypeName":"上册"}
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            searchVisiable: false,
            query: {},

            /*添加和修改园所*/
            form: {
                AgentId: null,
                SchoolName: "",
                LongCode: "0.0",
                LatCode: "0.0",
                Address: "", //详细地址
                PhoneNo: "", //园长电话
                ProvId: 0,
                CityId: 0,
                AreaId: 0,
                SchoolId: 0,
                PrincipalName: "", //园长
                AddPhoneNo: "", //园所电话
                Email: "",
                QQ: "",
                DataType: 0,
                Weixin: "" //微信
            },
            address: {
                Provinces_Id: '',
                City_Id: '',
                Area_Id: ''
            },
            update: false, //是否更新
            view: false, //查看
            dialogTitle: "", //显示隐藏

            /* 跟进情况列表 */
            followUpListVisiable: false,
            followUpList: [], //列表数据
            followUpTotalSize: 0, //列表总条数
            currentId: null,
            followItem: {},

            //子组件的Id
            childrenId: "",

            /*表单验证规则 */
            rules: {
                SchoolName: [{
                    required: true,
                    message: "请输入园所名称"
                }],
                PrincipalName: [{
                    required: true,
                    message: "请输入园长名称"
                }],
                Address: [{
                    required: true,
                    message: "请输入详细地址"
                }],
                AgentId: [{
                    required: true,
                    message: "请选择代理商"
                }],
                PhoneNo: [{
                        required: true,
                        message: "请输入园长电话"
                    },
                    {
                        validator: checkPhone,
                        trigger: 'blur'
                    }
                ],
                AddPhoneNo: [{
                        required: true,
                        message: "请输入园所电话"
                    },
                    {
                        validator: checkPhone,
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    methods: {
        inficial(val) {
            this.childrenId = val;
            this.$nextTick(function () {
                this.$refs.myofficial.Regularization({
                    id: val,
                    official: true
                });
            })
        },
        /*删除的部分*/
        handleSelectionChange(val) {
            this.sels = val;
        },
        handledel() {
            var ids = this.sels.map(item => item.Id).toString();
            var Params = {
                "Ids": ids
            }
            if (ids == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择删除内容',
                    type: 'warning'
                });
            } else {
                this.$confirm('确认删除选中记录吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.DeleteItem(Params)
                });
            }
        },
        /*分页部分 */

        //分页选定行
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        },
        //分页监听dd页面
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getList();
        },

        /*搜索部分*/
        toggleSearch() {
            this.searchVisiable = !this.searchVisiable;
        },
        getQueryList(val) {
            this.query = val;
            this.getList();
        },
        /*修改添加的处理函数块 */
        handleAdd() {
            this.$refs.schoolDetails.show({
                isAdd: true
            });
        },
        handleEdit(item) {
            this.$refs.schoolDetails.show({
                Id: item.Id,
                isUpdate: true
            });
        },
        handleview(item) {
            this.$refs.schoolDetails.show({
                Id: item.Id,
                isReadonly: true
            });
        },
        submit() {
            this.form.ProvId = this.address.Provinces_Id;
            this.form.CityId = this.address.City_Id;
            this.form.AreaId = this.address.Area_Id;
            if (this.update) {
                this.$refs["area"].validate();
                this.$refs["ruleform"].validate((valid) => {
                    if (valid) {
                        this.saveUpdate(this.form);
                    } else {
                        return false;
                    }
                });
            } else {
                this.$refs["area"].validate();
                this.$refs["ruleform"].validate((valid) => {
                    if (valid) {
                        this.saveSubmit(this.form);
                    } else {
                        return false;
                    }
                });
            }
        },
        dialogClose() {
            this.dialogVisible = false;
            this.$refs["ruleform"].resetFields();
            this.$refs["area"].resetFields();
            this.update = false;
            this.$refs["area"].cityList = []; //城市列表
            this.$refs["area"].areaList = []; //区\县列表
        },

        //打开跟进情况列表
        checkFollowUpList(id) {
            this.getFollowList({
                id: id
            }); //跟进情况列表
            this.followUpListVisiable = true;
            this.currentId = id;
        },
        //更新跟进情况列表
        refreshFollowUpList(type, val) {
            let options = {
                id: this.currentId
            };
            options[type] = val;
            this.getFollowList(options);
        },
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        },
        arrowClass() {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
        AgentList() {
            return this.$store.state.AgentList;
        }
    },
    //组件初始化
    created() {
        this.getList();
    }
}


// WEBPACK FOOTER //
// ./src/pages/school/purposeSchool/vm.js